import { FirebaseProjects, FirebaseTasks } from './index'
import mapper from './mapper'

const projectsDb = () => {

    const findOne = async (projectId) => {
        const doc = await FirebaseProjects.doc(projectId).get()
        return (doc.exists) ? mapper.get(doc) : null
      }

    const findAll = () => {
        return FirebaseProjects.orderBy('name')
    }

    const update = (projectId, delta) => {
        return FirebaseProjects.doc(projectId).update(delta)
    }

    const add = (project) => {
        return FirebaseProjects.add(project)
    }

    return Object.freeze({
        findOne,
        findAll,
        update,
        add
    })

}

const Projects = projectsDb()

export { Projects }
